import PropTypes from 'prop-types'
import EmpresasTiendasOficiales from './EmpresasTiendasOficiales'
import './TiendasOficiales.css'

function CategoriasTiendasOficiales(props) {
  return (
    <div className="item-tiendas-oficiales">
      <div className="col seccion-tiendas-oficiales">
        <h3>{props.categoria[0].descripcion}</h3>
        <br />
        <div className="row contenedor-tiendas-oficiales">
          {props.categoria.map((tienda, index) => (
            <EmpresasTiendasOficiales key={index} tienda={tienda} />
          ))}
        </div>
      </div>
    </div>
  )
}

CategoriasTiendasOficiales.propTypes = {
  categoria: PropTypes.arrayOf(
    PropTypes.shape({
      descripcion: PropTypes.string
    })
  ).isRequired
}

export default CategoriasTiendasOficiales
